export default {
  /**
   * 分为两种配置
   * 1、当前主题的摄像机参数
   * 2、当前地图的摄像机视野限制参数
   */

  //#region 相机参数

  中国: {
    centerCoord: [104.2441423, 34.3973044],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 0,
    distance: 6364256.8,
    heading: 0,
    pitch: 60,
    duration: 1,
    fly: true,
  },
  北京: {
    centerCoord: [116.3158036, 40.280554],
    coordType: 0,
    coordTypeZ: 0,
    coordZ:-41307.14,
    distance: 260643.24,
    heading: 0.8,
    pitch: 46.59,
    duration: 1,
    fly: true,
  },
  园区: {
    centerCoord: [116.2925561, 39.8282213],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: -3.06,
    distance: 81.91,
    heading: 0.14,
    pitch: 21.11,
    duration: 1,
    fly: true,
  },
  楼层: {
    centerCoord: [116.2925688, 39.8281607],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 8.13,
    distance: 25.4,
    heading: 358,
    pitch: 59.55,
    duration: 1,
    fly: true,
  },
  '分数据中心-01': {
    coordType: 0,
    coordTypeZ: 0,
    centerCoord: [116.2925561, 39.8282213],
    coordZ: -3.06,
    distance: 81.91,
    pitch: 21.11,
    heading: 0.14,
    duration: 1,
    fly: true,
  },

  建筑01: {
    centerCoord: [116.2925712, 39.82811],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 17.1,
    distance: 39.94,
    heading: 0.86,
    pitch: 15,
    duration: 1,
    fly: true,
  },

  F3: {
    centerCoord: [116.2925688, 39.8281607],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 8.13,
    distance: 25.4,
    heading: 358,
    pitch: 59.55,
    duration: 1,
    fly: true,
  },

  机柜组机房: {
    coordType: 0,
    coordTypeZ: 0,
    centerCoord: [116.2925551, 39.828192],
    coordZ: -0.17,
    distance: 26.5,
    pitch: 71.85,
    heading: 1.04,
    duration: 1,
    fly: true,
  },
  电池组机房: {
    coordType: 0,
    coordTypeZ: 0,
    centerCoord: [116.2926789, 39.828244],
    coordZ: 1.06,
    distance: 15.07,
    pitch: 60.76,
    heading: 359,
    duration: 1,
    fly: true,
  },
  UPS设备机房: {
    coordType: 0,
    coordTypeZ: 0,
    centerCoord: [116.2926691, 39.8282271],
    coordZ: -1.26,
    distance: 25.18,
    pitch: 44.54,
    heading: 0.14,
    duration: 1,
    fly: true,
  },
  'Box_F06-004-04_机柜容量': {
    centerCoord: [116.2924968, 39.8282285],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 3.29,
    distance: 11.66,
    heading: 20.57,
    pitch: 65.88,
    duration: 1,
    fly: true,
  },
  'F06-004-07_SM_设备机柜': {
    centerCoord: [116.2925103, 39.828201],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 8.94,
    distance: 2.8,
    heading: 180.49,
    pitch: 22.46,
    duration: 1,
    fly: true,
  },
  'Box_C03-004-04_机柜容量': {
    centerCoord: [116.2925106, 39.8281666],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 9,
    distance: 2.5,
    heading: 27.57,
    pitch: 48.88,
    duration: 1,
    fly: true,
  },
  'C03-004-04_SM_设备机柜': {
    centerCoord: [116.2925107, 39.8281657],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 9.23,
    distance: 1.87,
    heading: 0,
    pitch: 15.33,
    duration: 1,
    fly: false,
  },
  'Box_A01-004-04_机柜容量': {
    centerCoord: [116.2926091, 39.8281908],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: -2.69,
    distance: 15.87,
    heading: 13,
    pitch: 72.9,
    duration: 1,
    fly: true,
  },
  'A01-004-04_SM_机柜组': {
    coordType: 0,
    coordTypeZ: 0,
    centerCoord: [116.292618, 39.8281375],
    coordZ: 6.28,
    distance: 6.98,
    pitch: 36.1,
    heading: 179.32,
    duration: 1,
    fly: true,
  },
  'A01-003_SM_机柜组': {
    centerCoord: [116.2926186, 39.8281705],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 8.91,
    distance: 2.26,
    heading: 0.33,
    pitch: 17.33,
    duration: 1,
    fly: true,
  },
  门禁1002: {
    centerCoord: [116.2924855, 39.828172],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 9.26,
    distance: 2.95,
    heading: 89.23,
    pitch: 30.98,
    duration: 1,
    fly: true,
  },
  门禁1003: {
    centerCoord: [116.2926121, 39.8281432],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 12.99,
    distance: 1.36,
    heading: 269.56,
    pitch: 38.99,
    duration: 1,
    fly: true,
  },
  'C03-004-04_SM_配线架': {
    coordType: 0,
    coordTypeZ: 0,
    centerCoord: [116.2925105, 39.8281675],
    coordZ: 9.5,
    distance: 0.6,
    pitch: 17,
    heading: 1,
    fly: true,
    duration: 0.5,
  },
  'C03-004-04_SM_配线架设备反面': {
    coordType: 0,
    coordTypeZ: 0,
    centerCoord: [116.2925102, 39.8281675],
    coordZ: 9.5,
    distance: 0.6,
    pitch: 17,
    heading: 180,
    fly: true,
    duration: 0.5,
  },
  'C03-004-04_SM_数据服务器_虚拟机': {
    coordType: 0,
    coordTypeZ: 0,
    centerCoord: [116.2925105, 39.8281675],
    coordZ: 9.3,
    distance: 0.5,
    pitch: 17,
    heading: 0.16,
    fly: true,
    duration: 0.5,
  },
  'C03-004-04_SM_数据服务器_虚拟机设备反面': {
    coordType: 0,
    coordTypeZ: 0,
    centerCoord: [116.2925105, 39.8281675],
    coordZ: 9.3,
    distance: 0.5,
    pitch: 17,
    heading: 180.16,
    fly: true,
    duration: 0.5,
  },
  'C03-004-04_SM_路由器': {
    centerCoord: [116.2925105, 39.8281671],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 9.1,
    distance: 1.36,
    heading: 0.16,
    pitch: 17,
    fly: true,
    duration: 0.5,
  },
  'C03-004-04_SM_路由器设备反面': {
    centerCoord: [116.2925105, 39.8281671],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 9.1,
    distance: 1.36,
    pitch: 17,
    heading: 180.16,
    fly: true,
    duration: 0.5,
  },
  'C03-004-04_SM_交换机': {
    centerCoord: [116.2925104, 39.8281678],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 9.43,
    distance: 1.36,
    heading: 0.16,
    pitch: 17,
    fly: true,
    duration: 0.5,
  },
  'C03-004-04_SM_交换机设备反面': {
    centerCoord: [116.2925104, 39.8281678],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 9.43,
    distance: 1.36,
    heading: 180.16,
    pitch: 17,
    fly: true,
    duration: 0.5,
  },
  'C03-004-04_SM_服务器': {
    centerCoord: [116.2925105, 39.8281674],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 9.05,
    distance: 1.36,
    heading: 1.83,
    pitch: 15,
    fly: true,
    duration: 0.5,
  },
  'C03-004-04_SM_服务器设备反面': {
    centerCoord: [116.2925105, 39.8281674],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 9.05,
    distance: 1.36,
    heading: 180.83,
    pitch: 15,
    fly: true,
    duration: 0.5,
  },
  'C03-004-04_SM_网络存储服务器': {
    centerCoord: [116.2925105, 39.8281671],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 8.93,
    distance: 1.36,
    heading: 0.16,
    pitch: 18,
    fly: true,
    duration: 0.5,
  },
  'C03-004-04_SM_网络存储服务器设备反面': {
    centerCoord: [116.2925105, 39.8281671],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 8.93,
    distance: 1.36,
    heading: 180.16,
    pitch: 18,
    fly: true,
    duration: 0.5,
  },
  'C03-004-04_SM_GPU服务器': {
    centerCoord: [116.2925106, 39.8281674],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 8.82,
    distance: 1.36,
    heading: 0.49,
    pitch: 15,
    fly: true,
    duration: 0.5,
  },
  'C03-004-04_SM_GPU服务器设备反面': {
    centerCoord: [116.2925106, 39.8281674],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 8.82,
    distance: 1.36,
    heading: 180.49,
    pitch: 15,
    fly: true,
    duration: 0.5,
  },
  'F06-004-04_SM_配线架': {
    centerCoord: [116.2925102, 39.8282057],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 9.59,
    distance: 1.36,
    heading: 1.16,
    pitch: 15,
    duration: 1,
    fly: true,
  },
  API_C0300404_服务器_背_F02: {
    centerCoord: [116.2925107, 39.8281657],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 9.23,
    distance: 1.36,
    heading: 200,
    pitch: 15,
    duration: 1,
    fly: true,
  },
  API_C0300404_配线架_正_A40: {
    centerCoord: [116.2925098, 39.8281682],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 9.68,
    distance: 1.36,
    heading: 23,
    pitch: 19.72,
    duration: 1,
    fly: true,
  },
  'F06-004-04_SM_大型服务器': {
    centerCoord: [116.2925103, 39.8282045],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 8.92,
    distance: 1.36,
    heading: 0.82,
    pitch: 15,
    duration: 1,
    fly: true,
  },
  API_F0600407_大型服务器_背_A01: {
    centerCoord: [116.2925103, 39.828206],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 8.92,
    distance: 1.36,
    heading: 174.82,
    pitch: 15,
    duration: 1,
    fly: true,
  },
  'A01-004-04_SM_配线架': {
    centerCoord: [116.2926178, 39.8281667],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 9.7,
    distance: 1.36,
    heading: 1.67,
    pitch: 15,
    duration: 1,
    fly: true,
  },
  API_A0100404_配线架_正_A40: {
    centerCoord: [116.2926213, 39.8281668],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 9.69,
    distance: 1.36,
    heading: 1.67,
    pitch: 15,
    duration: 1,
    fly: true,
  },
  'A01-004-04_SM_服务器': {
    centerCoord: [116.2926182, 39.8281658],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 9.01,
    distance: 1.36,
    heading: 358.67,
    pitch: 15,
    duration: 1,
    fly: true,
  },
  API_A0100404_服务器_背_F02: {
    centerCoord: [116.2926224, 39.8281615],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 9.08,
    distance: 1.36,
    heading: 206,
    pitch: 15,
    duration: 1,
    fly: true,
  },
  Link_SM_机柜通讯线CF01: {
    centerCoord: [116.292514, 39.8281809],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 10.22,
    distance: 3.98,
    heading: 45,
    pitch: 45,
    duration: 1,
    fly: true,
  },
  Link_SM_机柜通讯线CA: {
    centerCoord: [116.2925855, 39.8281739],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 9.09,
    distance: 9.03,
    heading: 34.67,
    pitch: 59.33,
    duration: 1,
    fly: true,
  },
  整条链路视角: {
    centerCoord: [116.2925862, 39.8282114],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: -0.1,
    distance: 23.91,
    heading: 335.58,
    pitch: 58.43,
    fly: true,
    duration: 1,
  },
  链路二: {
    centerCoord: [116.2925819, 39.8282024],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: -0.94,
    distance: 23.91,
    heading: 335.58,
    pitch: 58.43,
    duration: 1,
    fly: true,
  },
  'A01-003_SM_机柜组': {
    centerCoord: [116.2925963, 39.8281888],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: -0.86,
    distance: 19.48,
    pitch: 65.88,
    heading: 20.57,
    duration: 1,
    fly: true,
  },
  'A01-001_SM_机柜组': {
    centerCoord: [116.2926114, 39.8281502],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 7.73,
    distance: 9.26,
    pitch: 65.88,
    heading: 20.57,
    duration: 1,
    fly: true,
  },
  'B02-002_SM_机柜组': {
    centerCoord: [116.2925545, 39.8281752],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 10,
    distance: 19.48,
    pitch: 65.88,
    heading: 20.57,
    duration: 1,
    fly: true,
  },
  'C03-001_SM_机柜组': {
    centerCoord: [116.2925083, 39.8281674],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 10,
    distance: 19.48,
    pitch: 65.88,
    heading: 20.57,
    duration: 1,
    fly: true,
  },
  'C03-002_SM_机柜组': {
    centerCoord: [116.2925102, 39.8281766],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: -0.09,
    distance: 19.48,
    pitch: 65.88,
    heading: 20.57,
    duration: 1,
    fly: true,
  },
  'B02-003_SM_机柜组': {
    centerCoord: [116.2925531, 39.828188],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: -0.16,
    distance: 19.48,
    pitch: 65.88,
    heading: 20.57,
    duration: 1,
    fly: true,
  },
  'C03-003_SM_机柜组': {
    coordType: 0,
    coordTypeZ: 0,
    centerCoord: [116.2925176, 39.828191],
    coordZ: 0.45,
    distance: 19.48,
    pitch: 65.88,
    heading: 20.57,
    duration: 1,
    fly: true,
  },
  'C03-004_SM_机柜组': {
    centerCoord: [116.2924997, 39.8281877],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 0.76,
    distance: 19.48,
    heading: 20.57,
    pitch: 65.88,
    duration: 1,
    fly: true,
  },
  'B02-004_SM_机柜组': {
    centerCoord: [116.29255, 39.828195],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 0.32,
    distance: 19.48,
    pitch: 65.88,
    heading: 20.57,
    duration: 1,
    fly: true,
  },
  'A01-004_SM_机柜组': {
    centerCoord: [116.2926028, 39.8281864],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: -2.83,
    distance: 19.48,
    pitch: 72.9,
    heading: 13,
    duration: 1,
    fly: true,
  },
  'D04-001_SM_机柜组': {
    centerCoord: [116.2925946, 39.8282091],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 0.4,
    distance: 19.48,
    pitch: 65.88,
    heading: 20.57,
    duration: 1,
    fly: true,
  },
  'D04-002_SM_机柜组': {
    centerCoord: [116.2925176, 39.828191],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 0.65,
    distance: 19.48,
    pitch: 65.88,
    heading: 20.57,
    duration: 1,
    fly: true,
  },
  'D04-003_SM_机柜组': {
    centerCoord: [116.2926132, 39.8281933],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 10.31,
    distance: 9.26,
    pitch: 65.88,
    heading: 20.57,
    duration: 1,
    fly: true,
  },
  'D04-004_SM_机柜组': {
    centerCoord: [116.2926062, 39.8282294],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 1.43,
    distance: 19.48,
    pitch: 65.88,
    heading: 20.57,
    duration: 1,
    fly: true,
  },
  'E05-001_SM_机柜组': {
    centerCoord: [116.2925481, 39.8282087],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 1.19,
    distance: 19.48,
    pitch: 65.88,
    heading: 20.57,
    duration: 1,
    fly: true,
  },
  'E05-002_SM_机柜组': {
    centerCoord: [116.2925591, 39.8282176],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 1.54,
    distance: 19.48,
    pitch: 65.88,
    heading: 20.57,
    duration: 1,
    fly: true,
  },
  'E05-003_SM_机柜组': {
    centerCoord: [116.2925516, 39.8282212],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 1.89,
    distance: 19.48,
    pitch: 65.88,
    heading: 20.57,
    duration: 1,
    fly: true,
  },
  'E05-004_SM_机柜组': {
    centerCoord: [116.2925542, 39.828225],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 2.08,
    distance: 19.48,
    pitch: 65.88,
    heading: 20.57,
    duration: 1,
    fly: true,
  },
  'F06-001_SM_机柜组': {
    centerCoord: [116.2925172, 39.828208],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 1.69,
    distance: 19.48,
    pitch: 65.88,
    heading: 20.57,
    duration: 1,
    fly: true,
  },
  'F06-002_SM_机柜组': {
    centerCoord: [116.2925201, 39.8282138],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 1.99,
    distance: 19.48,
    pitch: 65.88,
    heading: 20.57,
    duration: 1,
    fly: true,
  },
  'F06-003_SM_机柜组': {
    centerCoord: [116.2925306, 39.8281935],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 11.77,
    distance: 9.26,
    pitch: 65.88,
    heading: 20.57,
    duration: 1,
    fly: true,
  },
  'F06-004_SM_机柜组': {
    centerCoord: [116.2925205, 39.8282356],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 3.31,
    distance: 19.48,
    pitch: 65.88,
    heading: 20.57,
    duration: 1,
    fly: true,
  },
  'A01-002_SM_机柜组': {
    centerCoord: [116.2925938, 39.8281775],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: -1.5,
    distance: 19.48,
    pitch: 65.88,
    heading: 20.57,
    duration: 1,
    fly: true,
  },
  'B02-001_SM_机柜组': {
    centerCoord: [116.2925542, 39.8281725],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: -1.11,
    distance: 19.48,
    pitch: 65.88,
    heading: 20.57,
    duration: 1,
    fly: true,
  },
  //#endregion

  //#region 视野限制参数
  默认: {
    center: [
      [-0.00129918392, -0.00106545069]
    ],
    coordType: 0,
    coordTypeZ: 0,
    limitYaw: [0, 359],
    limitPitch: [15, 80],
    limitCoordZ: [-10, 15000],
    limitDistance: [0, 160000],
    radius: 10000000,
  },

  //#endregion
}